module.exports = __webpack_public_path__ + "img/zhunzheng.958d5b4f.png";